import { MultipleViewTypeListActiveItemPreviewCloseButton } from '../../../MultipleViewTypeList'
import { PageEmptyState } from '../../../PageEmptyState'

import * as styles from './RentalPortalViewingsPreviewEmpty.module.css'

function RentalPortalViewingsPreviewEmpty({
  onClosePreview,
  ...emptyStateProps
}) {
  return (
    <div className={styles.RentalPortalViewingsPreviewEmpty}>
      <div className={styles.close}>
        <MultipleViewTypeListActiveItemPreviewCloseButton
          onClose={onClosePreview}
        />
      </div>
      <PageEmptyState {...emptyStateProps} className={styles.emptyState} />
    </div>
  )
}

export default RentalPortalViewingsPreviewEmpty
